export const createFunctionalityIndicatorsService = (fetch) => async (data) => {
  try {
    const response = await fetch({
      method: "post",
      url: "/api/v1/funcionamiento/indicadores",
      body: data,
    });
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
